<script>
    import {createEventDispatcher} from 'svelte/internal';
    import Icon from "../components/Icon.svelte";

    export let size = 18;
    export let disabled = false;
    export let topRight = false;

    const dispatch = createEventDispatcher();

    const onClick = () => {
        if (!disabled) {
            dispatch('click');
        }
    };
</script>

<div class="close-button" class:display-absolute={ topRight } on:click="{ onClick }" class:disabled={ disabled }>
    <Icon name="x" {size} strokeWidth="2"/>
</div>

<style>
    .close-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 25px;
        height: 25px;
        color: #d2d2d2;
        line-height: 1;
        cursor: pointer;
    }

    .close-button:hover {
        color: #bcbcbc;
    }

    .close-button.disabled {
        color: #e5e5e5;
    }

    .display-absolute {
        position: absolute;
        top:15px;
        right:15px;
    }
</style>